import React, {useEffect, useState} from "react";
import {
    ActionTypeEnum,
    DailyTransactionTypeEnum,
    PaymentValueDetailsModel, PosTransactionChangeTypeEnum,
    PosUserPermissionActionTypeEnum,
    RequestActionModel,
    RowStateEnum,
    TransactionDetailResponseModel,
    TransactionItemPermissionActionResponseModel,
    TransactionItemResponseModel,
} from "../../../models";
import {getLabelName, getUserId, isArabicCurrentLanguage, scrollToDocumentTop,} from "../../../utils";
import {
    ErrorValidationBox,
    LoadingBox,
    PosActionButtons,
    PosTransactionItemsTable,
    PosTransactionSummary,
    PosUserPermissionLogin,
    TextBox,
    ToastBox,
} from "./../..";
import {
    handleCalculateItemRecordValuesUpdate,
    handlePosTransactionTotalValues,
    handleUpdateExistingTransactionValues,
    UpdateTransactionActionUser,
} from "../common/businessLogic/transactionBl";
import {
    getPosCategories,
    getPosItemList,
    handleAddItemPos,
    handleDeleteItemPos,
    handleResetTransactionPos,
    handleSaveAndPay,
    handleShowPrint,
    handleSortAlphabetically,
    handleValidateTransaction,
    initializePosTransactionValuesConfiguration,
    transformReservedTransactionData,
} from "../common/businessLogic/posTransactionBl";
import {cancelReservation, saveTransaction,} from "../../../serviceBroker/transactionApiServiceBroker";
import {usePosTransactionsState} from "./helper/state/posTransactionsState";
import {getUserTransactionsSettings} from "../../../serviceBroker/userApiServiceBroker";
import {SystemConfiguration} from "../../../configuration";
import {UpdateTransactionItemStateOnChange} from "../common/businessLogic/commonBl";
import {useSidebar} from "../../../hooks";
import POSInvoiceType, {POSInvoiceTypeProps,} from "./restaurantPOS/posInvoiceType";
import {transactionDetailInitialValues} from "../common/initialValues/initialValues";
import {
  cardBtnClickActiveStyle,
  cardBtnClickStyle, cardDetailsContainerStyle,
  cardDisplayStyle, cardInfoStyle, cardPosStyle, cardsContainerPosStyle,
  // cardsDisplayStyle,
  cardsGroupPosStyle,
  customCategoryItemActiveStyle,
  customCategoryItemStyle,
  customCategoryListStyle
} from "../common/css/posCss";
import {searchItemsTransaction} from "../../../serviceBroker/itemApiServiceBroker";
import _ from "lodash";

interface PosTransactionsMainComponentProps {
  InvoiceTypeComponent?: React.FC<POSInvoiceTypeProps>;
  transactionTypeId: DailyTransactionTypeEnum;
}

export const PosTransactionsMainComponent: React.FC<
  PosTransactionsMainComponentProps
> = ({ InvoiceTypeComponent, transactionTypeId }) => {
  //#region state
  const {
      loading,
      setLoading,
      isItemListLoading,
      setIsItemListLoading,
      validationErrors,
      setValidationErrors,
      toastModel,
      setToastModel,
      categoriesList,
      setCategoriesList,
      itemsList,
      setItemsList,
      transactionData,
      setTransactionData,
      employee,
      setEmployee,
      beneficiary,
      setBeneficiary,
      showPaymentDetailsModel,
      setShowPaymentDetailsModel,
      activeTabItem,
      setActiveTabItem,
      printTransactionId,
      setPrintTransactionId,
      showPrintoutPdfModel,
      setShowPrintoutPdfModel,
      transactionType,
      searchText,
      setSearchText,
      lastSearchValue,
      setLastSearchValue,
      setSearchTimeout,
      posSetting,
      setPosSetting,
      companySettings,
      setTransactionUserSettingList,
      transactionUserSetting,
      setTransactionUserSetting,
      itemPerAction,
      setItemPerAction,
      userActionUiModel,
      setUserActionUiModel,
      userTransactionPermissionRequest,
      setUserTransactionPermissionRequest,
      searchTextInputRef,
  } = usePosTransactionsState(transactionTypeId);
  const { setIsOpen } = useSidebar();
  const [activeItemIndex, setActiveItemIndex] = useState<number>(0);
  //#endregion
  //#region variables
  const isArabic = isArabicCurrentLanguage();
  //#endregion
  //#region functions
  const handleItemsList = async (categoryId: number) => {
    setIsItemListLoading(true);
    setActiveTabItem(categoryId);
      const Result = await getPosItemList({
          categoryId,
          storeId: posSetting.Store_ID,
      });
    setItemsList(Result);
    setIsItemListLoading(false);
  };
  const handleAction = async (request: RequestActionModel) => {
      switch (request.action) {
          case ActionTypeEnum.AddPaymentValuesSuccess:
              setShowPaymentDetailsModel(false);
              const paymentDetails: PaymentValueDetailsModel =
                  request.request as PaymentValueDetailsModel;
              let dataObjet: TransactionDetailResponseModel = {
                  ...transactionData,
                  CashMoney: paymentDetails.cash,
                  CardMoney: paymentDetails.credit,
                  DelayMoney: paymentDetails.delay,
                  OthersMoney: paymentDetails.voucher,
                  Voucher_ID: paymentDetails.voucherId,
                  TransactionType:
                      transactionData.TransactionType === 0
                          ? Number(transactionType)
                          : transactionData.TransactionType ===
                          DailyTransactionTypeEnum.Reserve_Restaurant_Bill
                              ? DailyTransactionTypeEnum.POSRestaurant
                              : transactionData.TransactionType,
              };
              setTransactionData(dataObjet);
              await handleSaveTransactionDetails(dataObjet);
              break;
          case ActionTypeEnum.ResetObject:
              setLoading(true);
              await handleResetTransactionPos(
                  setTransactionData,
                  beneficiary,
                  setBeneficiary,
                  employee,
                  setEmployee,
                  setValidationErrors,
                  setPosSetting,
                  transactionType
              );
              setLoading(false);
              break;
          case ActionTypeEnum.AddBeneficiaryResponse:
              setBeneficiary({
                  value: request.request.request.ID,
                  name: request.request.request.Name_En,
                  nameAr: request.request.request.Name,
              });
              break;
          case ActionTypeEnum.PrintPdf:
              await handleShowPrint(
                  printTransactionId,
                  setShowPrintoutPdfModel,
                  setValidationErrors
              );
              break;
          case ActionTypeEnum.Save:
              await handleSaveAndPay(
                  {...transactionData},
                  setShowPaymentDetailsModel,
                  setValidationErrors
              );
              break;
          case ActionTypeEnum.SelectEmployeeResponse:
              setEmployee(request.request);
              break;
          case ActionTypeEnum.SelectCustomerResponse:
              setBeneficiary(request.request);
              setTransactionData((prev) => ({
                  ...prev,
                  Customer_ID: request.request.value,
              }));
              break;
          case ActionTypeEnum.SelectItemResponse:
              setLoading(true);
              await handleAddItemPos(
                  request.request,
                  setTransactionData,
                  transactionData
              );
              setLoading(false);
              break;
          case ActionTypeEnum.TransactionRefund:
              setLoading(true);
              setSearchText("");
              setValidationErrors([]);
              const modifyTransactionObject: TransactionDetailResponseModel =
                  request.request;
              //setTransactionType( modifyTransactionObject.TransactionType);
              if (
                  modifyTransactionObject.TransactionDetaillist !== null &&
                  modifyTransactionObject.TransactionDetaillist !== undefined &&
                  modifyTransactionObject.TransactionDetaillist.length !== 0
              ) {
                  modifyTransactionObject.TransactionDetaillist.forEach((row) => {
                      row = handleUpdateExistingTransactionValues(row);
                      return {...row};
                  });
              }
              const dataObject = handlePosTransactionTotalValues(
                  modifyTransactionObject
              );
              setTransactionData({
                  ...dataObject,
                  TransactionDetaillist: [...dataObject.TransactionDetaillist],
              });
              setLoading(false);
              break;
          case ActionTypeEnum.UpdatePosOptions:
              setLoading(true);
              setTransactionData(request.request);
              setLoading(false);
              break;
          case ActionTypeEnum.SelectReservedTransaction:
              setLoading(true);
              const reservedTableTransaction = transformReservedTransactionData(
                  request.request
              );
              setTransactionData(reservedTableTransaction);
              setLoading(false);
              break;
          case ActionTypeEnum.CancelReservation:
              setLoading(true);
              //  here goes tha api call
              await cancelReservation(
                  transactionData.ID,
                  transactionData.User_Create,
                  request.request.reason
              );
              await handleResetTransactionPos(
                  setTransactionData,
                  beneficiary,
                  setBeneficiary,
                  employee,
                  setEmployee,
                  setValidationErrors,
                  setPosSetting,
                  transactionType
              );
              setLoading(false);
              break;
          case ActionTypeEnum.ReserveTable:
              // setLoading(true);
              // const reservedTableTransaction = transformReservedTransactionData(
              //   request.request
              // );
              // setTransactionData(reservedTableTransaction);
              // setLoading(false);
              const isUpdated = !!transactionData.ID;
              await handleSaveTransactionDetails({
                  ...transactionData,
                  TransactionType: DailyTransactionTypeEnum.Reserve_Restaurant_Bill,
                  rowState: isUpdated ? RowStateEnum.Update : RowStateEnum.Add,
                  User_Update: isUpdated ? getUserId() : 0,
              });
              break;
          case ActionTypeEnum.DeleteTransactionItem:
              if (posSetting.AllowDeleteItems) {
                  handleDeleteItemPos(
                      request.request,
                      setTransactionData,
                      transactionData
                  );
              } else {
                  setItemPerAction(request.request);
                  setUserActionUiModel({
                      ...userActionUiModel,
                      userPermissionType:
                      PosUserPermissionActionTypeEnum.DeleteItemAction,
                      showLoginModel: true,
                  });
              }
              break;
          case ActionTypeEnum.EditTransactionItemPrice:
              if (posSetting.HasPermToEditPrice) {
                  await UpdateTransactionItemStateOnChange(
                      setTransactionData,
                      transactionData,
                      request.request
                  );
              } else {
                  setItemPerAction(request.request);
                  setUserActionUiModel({
                      ...userActionUiModel,
                      userPermissionType:
                      PosUserPermissionActionTypeEnum.EditItemPriceAction,
                      showLoginModel: true,
                  });
              }
              break;
          case ActionTypeEnum.EditTransactionItemDiscount:
              if (posSetting.HasPermToDiscount) {
                  await UpdateTransactionItemStateOnChange(
                      setTransactionData,
                      transactionData,
                      request.request
                  );
              } else {
                  setItemPerAction(request.request);
                  setUserActionUiModel({
                      ...userActionUiModel,
                      userPermissionType:
                      PosUserPermissionActionTypeEnum.EditItemDiscountAction,
                      showLoginModel: true,
                  });
              }
              break;
          case ActionTypeEnum.GetUserPOSPermission:
              const requestObject: TransactionItemPermissionActionResponseModel =
                  request.request as TransactionItemPermissionActionResponseModel;
              switch (requestObject.userPermissionType) {
                  case PosUserPermissionActionTypeEnum.DeleteItemAction:
                      // @ts-ignore
                      handleDeleteItemPos(
                          itemPerAction!,
                          setTransactionData,
                          transactionData
                      );
                      setItemPerAction(null);
                      break;
                  case PosUserPermissionActionTypeEnum.EditItemPriceAction:
                      // @ts-ignore
                      await UpdateTransactionItemStateOnChange(
                          setTransactionData,
                          transactionData,
                          itemPerAction!
                      );
                      setUserTransactionPermissionRequest({
                          ...userTransactionPermissionRequest,
                          isTransactionPriceEditable: true,
                      });
                      setItemPerAction(null);
                      break;
                  case PosUserPermissionActionTypeEnum.EditItemDiscountAction:
                      // @ts-ignore
                      await UpdateTransactionItemStateOnChange(
                          setTransactionData,
                          transactionData,
                          itemPerAction!
                      );
                      setUserTransactionPermissionRequest({
                          ...userTransactionPermissionRequest,
                          isTransactionDiscountEditable: true,
                      });
                      setItemPerAction(null);
                      break;
              }
              break;
          case ActionTypeEnum.RefundWithoutBill:
              setTransactionData({
                  ...transactionDetailInitialValues,
                  TransactionType: DailyTransactionTypeEnum.POSSalesRefund,
              });
              break;
          case ActionTypeEnum.UpdateTransactionItem:
          case ActionTypeEnum.UpdateItemQuantity:
              const {updatedRow, changeType} = request.request as {
                  updatedRow: TransactionItemResponseModel;
                  changeType: PosTransactionChangeTypeEnum;
              };

              const handleUpdatedTransaction = (item: TransactionItemResponseModel): TransactionDetailResponseModel => {
                  const updatedList = transactionData.TransactionDetaillist.map((item) =>
                      item.rowKey === updatedRow.rowKey ? {...updatedRow} : item
                  );
                  // Keep deleted rows only if they have a valid ID
                  const finalList = updatedList.filter(
                      (item) => item.rowState !== RowStateEnum.Delete || (item.ID !== null && item.ID !== 0 && item.ID !== undefined)
                  );
                  return {
                      ...transactionData,
                      TransactionDetaillist: finalList,
                  };
              };

              const handleQuantityChange = (request: TransactionItemResponseModel): TransactionDetailResponseModel => {
                  const transactionRequest = handleUpdatedTransaction(request);
                  let obj: TransactionItemResponseModel[] = _.map(
                      transactionRequest.TransactionDetaillist,
                      (row) => {
                          if (row.rowKey == request.rowKey && row.rowState === request.rowState) {
                              request.latestModifiedDate = new Date();
                              request = handleCalculateItemRecordValuesUpdate(request);
                              return request;
                          } else {
                              return row;
                          }
                      }
                  );
                  return {
                      ...transactionData,
                      TransactionDetaillist: obj,
                  };
              };

              const handleCalculateTransactionTotalValue = (request: TransactionDetailResponseModel): TransactionDetailResponseModel => {
                  return handlePosTransactionTotalValues({
                      ...request,
                      TransactionDetaillist: request.TransactionDetaillist.filter(item => item.rowState !== RowStateEnum.Delete)
                  });
              };

              let updatedTransaction: TransactionDetailResponseModel;
              let recalculated: Partial<TransactionDetailResponseModel>;

              switch (changeType) {
                  case PosTransactionChangeTypeEnum.QuantityChanged:
                      updatedTransaction = handleUpdatedTransaction(updatedRow);
                      updatedTransaction = handleQuantityChange(updatedRow);
                      recalculated = handleCalculateTransactionTotalValue(updatedTransaction);
                      setTransactionData({
                          ...updatedTransaction,
                          ...recalculated,
                      });
                      break;
                  default:
                      updatedTransaction = handleUpdatedTransaction(updatedRow);
                      updatedTransaction = handleQuantityChange(updatedRow);
                      recalculated = handleCalculateTransactionTotalValue(updatedTransaction);
                      setTransactionData({
                          ...updatedTransaction,
                          ...recalculated,
                      });
                      break;
              }
              break;
      }
  };
  const handleSaveTransactionDetails = async (
    request: TransactionDetailResponseModel
  ) => {
    setLoading(true);
    const errors = await handleValidateTransaction(request);
    if (errors.length !== 0) {
      setValidationErrors(errors);
      return;
    }
    request = UpdateTransactionActionUser(request);
    const result = await saveTransaction(request);
    if (
      result.Errors !== null &&
      result.Errors !== undefined &&
      result.Errors.length !== 0
    ) {
      scrollToDocumentTop();
      setValidationErrors(result.Errors);
    } else {
      scrollToDocumentTop();
      setPrintTransactionId(result.Result?.TransactionId || 0);
      setTransactionData({ ...transactionDetailInitialValues });
      setToastModel({ ...toastModel, show: true });
      setValidationErrors([]);
    }
    setLoading(false);
  };
  //#endregion
  //#region useEffect
  useEffect(() => {
    if (searchTextInputRef.current) {
      searchTextInputRef.current.focus();
    }
    const fillData = async () => {
      setLoading(true);
      let categories = await getPosCategories();
      handleSortAlphabetically(categories);
      setCategoriesList(categories);
      await initializePosTransactionValuesConfiguration(
        setTransactionData,
        transactionData,
        beneficiary,
        setBeneficiary,
        employee,
        setEmployee,
        setPosSetting,
        transactionType,
        [
          transactionTypeId,
          DailyTransactionTypeEnum.ReturnPOSRestaurant,
          DailyTransactionTypeEnum.POSSalesRefund,
        ]
      );
      const settingsList = await getUserTransactionsSettings(
        [
          DailyTransactionTypeEnum.POSSales,
          DailyTransactionTypeEnum.PurchasesInvoice,
          DailyTransactionTypeEnum.POSSalesRefund,
        ],
        true,
        SystemConfiguration.cacheKey_Configurations.setting.posSettingsList
      );
      const currentTransactionSetting = settingsList.filter(
        (p) => p.TransactionType_ID === transactionType
      )[0];
      setUserTransactionPermissionRequest({
        ...userTransactionPermissionRequest,
        isPosPriceEditable: posSetting.HasPermToEditPrice,
        isPosDiscountEditable: posSetting.HasPermToDiscount,
      });
      setTransactionUserSettingList(settingsList);
      setTransactionUserSetting(currentTransactionSetting);
      setLoading(false);
    };
    fillData().then(() => {});
  }, []);
  useEffect(() => {
    setIsOpen(true);
    return () => {
      setIsOpen(false); // Close the sidebar when this component unmounts
    };
  }, [setIsOpen]);
  //# endregion
  //#region html
  return (
    <>
      {loading && <LoadingBox />}
      {<ErrorValidationBox errors={validationErrors} />}
      {toastModel.show && (
        <ToastBox
          isShown={toastModel.show}
          header={toastModel.header}
          body={toastModel.body}
          variant={toastModel.variant}
          delayDuration={toastModel.delayDuration}
          onCloseEvent={() => {
            setToastModel({ ...toastModel, show: false });
          }}
        />
      )}
      <>
        <PosActionButtons
          transactionType={transactionTypeId}
          transactionData={transactionData}
          setTransactionData={setTransactionData}
          showPaymentDetailsModel={showPaymentDetailsModel}
          setShowPaymentDetailsModel={setShowPaymentDetailsModel}
          showPrintoutPdfModel={showPrintoutPdfModel}
          setShowPrintoutPdfModel={setShowPrintoutPdfModel}
          beneficiary={beneficiary}
          employee={employee}
          posSetting={posSetting}
          transactionSetting={transactionUserSetting}
          printTransactionId={printTransactionId}
          onActionEvent={async (o) => {
            await handleAction(o);
          }}
          hasOrdersList={
              transactionTypeId === DailyTransactionTypeEnum.POSRestaurant ||
              transactionTypeId === DailyTransactionTypeEnum.ReturnPOSRestaurant
          }
        />
        <div style={cardsContainerPosStyle}>
          <div style={cardsGroupPosStyle} className="row g-3">
            <div style={cardPosStyle} className="col-lg-2">
              <ul style={customCategoryListStyle}>
                {categoriesList?.map((item, index) => {
                  const isActive = activeTabItem === Number(item.value);
                  return (
                      <li
                          key={index}
                          id={`category_btn_${index}`}
                          style={{
                            ...customCategoryItemStyle,
                            ...(isActive ? customCategoryItemActiveStyle : {}),
                          }}
                          onClick={async () => await handleItemsList(Number(item.value))}
                      >
                        {isArabic ? item.nameAr : item.name}
                      </li>
                  );
                })}
              </ul>
            </div>
            <div style={cardPosStyle} className="col-lg-5">
              <div style={cardInfoStyle}>
                {InvoiceTypeComponent && (
                    <POSInvoiceType
                        setTransactionData={setTransactionData}
                        InvoiceType={transactionData.InvoiceType}
                        onActionEvent={async (o) => {
                          await handleAction(o);
                        }}
                    >
                      <POSInvoiceType.DeliveryButton
                          onActionEvent={async (o) => {
                            await handleAction(o);
                          }}
                      />
                      <POSInvoiceType.TakeawayButton
                          onActionEvent={async (o) => {
                            await handleAction(o);
                          }}
                      />
                      <POSInvoiceType.DineInButton
                          table_id={transactionData.Table_ID}
                          onActionEvent={async (o) => {
                            await handleAction(o);
                          }}
                      />
                    </POSInvoiceType>
                )}
                <TextBox
                    inputName="searchText"
                    inputValue={searchText}
                    labelName={""}
                    inputRef={searchTextInputRef}
                    placeHolder={getLabelName("search")}
                    onChange={(e: any) => {
                      setSearchText(e.target.value);
                    }}
                    onBlur={async (e:any) => {
                        const val: string  = e.target.value?? "";
                        if (val == lastSearchValue) {
                            return;
                        }
                        // Check if blur is from clicking POS buttons
                        const relatedTarget = e.relatedTarget;
                        if (relatedTarget && relatedTarget.closest('.pos-tools')) {
                            return;
                        }

                        const timeout = setTimeout(async () => {
                            setLastSearchValue(val);
                            setSearchText(val);

                            let items: TransactionItemResponseModel[];
                            setLoading(true);
                            if (val != null && val != "") {
                                items = (await searchItemsTransaction({categoryId: null, name: val}))?.Result || [];
                            } else {
                                items = await getPosItemList({
                                    categoryId: activeTabItem,
                                    nameAndCode: null,
                                    barCode: null,
                                    storeId: posSetting.Store_ID,
                                });
                            }
                            if (items !== null && items.length != 0) {
                                setItemsList(items);
                            }
                            setLoading(false);
                        }, 100);

                        setSearchTimeout(timeout);
                    }}
                />
                <LoadingBox isLoading={isItemListLoading}>
                {itemsList.length > 0 ? (
                    // <div style={cardsDisplayStyle} className="cards-display">
                     <div className="cards-display">
                      {itemsList?.map((selectedItem, index) => (
                          <div style={cardDisplayStyle} key={index}>
                            <button
                                type="button"
                                style={{
                                  ...cardBtnClickStyle,
                                  ...(activeItemIndex == (selectedItem.ItemUnit_ID ?? -1) ? cardBtnClickActiveStyle : {})
                                }}
                                id={`item_btn_${index}`}
                                onClick={async () => {
                                 await  handleAddItemPos(
                                      selectedItem,
                                      setTransactionData,
                                      transactionData
                                  );
                                  setActiveItemIndex(selectedItem.ItemUnit_ID ?? index);
                                }}
                            >
                              {isArabic ? selectedItem.ItemName : selectedItem.ItemName_En}
                            </button>
                          </div>
                      ))}
                    </div>
                ) : (
                    <div className="text-center p-4 text-muted">{getLabelName("No items found")} </div>
                )}
                </LoadingBox>
              </div>
            </div>
            <div className="col-lg-5 " style={{...cardPosStyle,...cardDetailsContainerStyle}}>
              {transactionData.TransactionDetaillist.length > 0 && (
                  <div className="transaction-table-container">
                    <PosTransactionItemsTable
                        transactionTypeId={transactionTypeId}
                        data={transactionData.TransactionDetaillist.filter(
                            (item) => item.rowState !== RowStateEnum.Delete
                        )}
                        handleAction={handleAction}

                    />
                  </div>
              )}
              <PosTransactionSummary
                  companySettings={companySettings}
                  data={transactionData}
              />
            </div>
          </div>
        </div>
      </>
      {userActionUiModel.showLoginModel && (
        <PosUserPermissionLogin
          userPermissionType={userActionUiModel.userPermissionType}
          onActionEvent={async (o: RequestActionModel) => {
            setUserActionUiModel({
              ...userActionUiModel,
              showLoginModel: false,
            });
            await handleAction(o);
          }}
        />
      )}
    </>
  );
  //#endregion
};
